export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_streetz-media-ai/artifacts/by2uhrda_CROPPED%20white%20mystreetz.jpeg";

export const NAV_LINKS = [
    { label: "HOME", to: "/" },
    { label: "MUSIC", to: "/category/Music" },
    { label: "NEWS", to: "/category/News" },
    { label: "STREET CULTURE", to: "/category/Street%20Talk" },
    { label: "SPORTS", to: "/category/Sports" },
    { label: "ARTISTS", to: "/artists" },
    { label: "PODCASTS", to: "/m/podcasts" },
    { label: "PLAYLISTS", to: "/m/playlists" },
    { label: "VIDEOS", to: "/m/videos" },
    { label: "EVENTS", to: "/m/events" },
    { label: "SHOP", to: "/shop" },
];

export const DISCOVER_CARDS = [
    { key: "podcasts", title: "PODCASTS", desc: "Real talks. Real people. Real stories.", icon: "Mic",
      image: "https://images.unsplash.com/photo-1612534859320-79465795d8dc?w=900&q=80", to: "/m/podcasts" },
    { key: "playlists", title: "PLAYLISTS", desc: "Curated hits. Updated every week.", icon: "Music2",
      image: "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=900&q=80", to: "/m/playlists" },
    { key: "interviews", title: "INTERVIEWS", desc: "Inside conversations with the culture.", icon: "Headphones",
      image: "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?w=900&q=80", to: "/m/interviews" },
    { key: "videos", title: "VIDEOS", desc: "The hottest videos in one place.", icon: "PlayCircle",
      image: "https://images.unsplash.com/photo-1540039155733-5bb30b53aa14?w=900&q=80", to: "/m/videos" },
    { key: "events", title: "EVENTS", desc: "Parties, shows & major events.", icon: "CalendarDays",
      image: "https://images.unsplash.com/photo-1501386761578-eac5c94b800a?w=900&q=80", to: "/m/events" },
];

export const FOOTER_QUICK = [
    { key: "discovery", title: "AI MUSIC DISCOVERY", desc: "Find songs, artists & vibes that match your taste.", cta: "TRY NOW", to: "/discover", icon: "Sparkles" },
    { key: "community", title: "COMMUNITY", desc: "Read real stories from MyStreetz readers across the streets.", cta: "READ STORIES", to: "/community", icon: "Users" },
    { key: "upload", title: "UPLOAD YOUR STORY", desc: "Got a story to share? We want to hear from you.", cta: "UPLOAD", to: "/story", icon: "Upload" },
    { key: "shop", title: "SHOP", desc: "Rep the culture. Grab exclusive MyStreetz merch.", cta: "SHOP NOW", to: "/shop", icon: "ShoppingBag" },
];
